const normalizePrefectureIdsByWorkStyle = (
  workStyle,
  prefectureIds,
) => {
  return workStyle === "remote" ? [] : prefectureIds;
};

export default normalizePrefectureIdsByWorkStyle;